// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"aa1cb975","275":"07a11401","879":"01933af6"}[chunkId] + ".chunk.css";
};